export default __webpack_public_path__ + "static/media/practice-test-9.28717722.csv";